import React from "react";
import { CircleAlert } from "lucide-react";

/**
 * Inline error state for failed GET/fetch requests — never a modal.
 * message - what went wrong, shown under the heading
 * onRetry - called when the user taps Retry
 * title   - optional heading, defaults to a generic one
 */
const FetchErrorState = ({ message = "We couldn't load this right now.", onRetry, title = "Something went wrong" }) => {
  return (
    <div className="flex flex-col items-center justify-center py-16 px-4 text-center">
      <div className="w-16 h-16 flex items-center justify-center rounded-full border-2 border-black mb-3">
        <CircleAlert className="w-8 h-8 text-black" />
      </div>
      <h3 className="text-base font-semibold text-gray-900 mb-1">{title}</h3>
      <p className="text-sm text-gray-500 max-w-xs mb-4">{message}</p>
      {onRetry && (
        <button
          onClick={onRetry}
          className="px-5 py-2 bg-black text-white text-sm font-semibold rounded-full hover:bg-gray-800 active:scale-95 transition-all"
        >
          Retry
        </button>
      )}
    </div>
  );
};

export default FetchErrorState;